import type { AreaFilter } from '@tempo-io/notification-dto';
import { parseResponse } from 'hono/client';
import { getNotificationApi } from './getNotificationApi';

export const TIME_RANGE_FILTERS = [
  'all',
  'this-week',
  'last-week',
  'this-month',
  'last-month',
  'custom',
] as const;
export type TimeRangeFilter = (typeof TIME_RANGE_FILTERS)[number];

export const NOTIFICATION_VIEWS = ['inbox', 'unread'] as const;
export type NotificationView = (typeof NOTIFICATION_VIEWS)[number];

export const getNotifications = async ({
  cursor,
  unread,
  area,
  from,
  to,
}: {
  cursor?: string | null;
  unread?: boolean;
  area?: AreaFilter;
  from?: string;
  to?: string;
}) => {
  const api = getNotificationApi();
  return parseResponse(
    api.notifications.v1.$get({
      query: {
        limit: '20',
        ...(cursor ? { cursor } : {}),
        ...(unread ? { unread: 'true' } : {}),
        ...(area && area !== 'all' ? { area } : {}),
        ...(from ? { from } : {}),
        ...(to ? { to } : {}),
      },
    }),
  );
};

export const getUnreadCount = async (): Promise<number> => {
  const api = getNotificationApi();
  const data = await parseResponse(api.notifications.v1['unread-count'].$get());
  return data.count;
};

export const markNotificationAsRead = async (notificationId: number): Promise<void> => {
  const api = getNotificationApi();
  await api.notifications.v1[':notificationId'].read.$patch({
    param: { notificationId: String(notificationId) },
  });
};

export const markNotificationsAsReadBulk = async (ids: number[]): Promise<{ count: number }> => {
  const api = getNotificationApi();
  return parseResponse(api.notifications.v1.read.$patch({ json: { ids } }));
};

export const markAllNotificationsAsRead = async (): Promise<{ count: number }> => {
  const api = getNotificationApi();
  return parseResponse(api.notifications.v1['read-all'].$patch());
};

export const markNotificationAsUnread = async (notificationId: number): Promise<void> => {
  const api = getNotificationApi();
  await api.notifications.v1[':notificationId'].unread.$patch({
    param: { notificationId: String(notificationId) },
  });
};
